import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { DashboardDataUtility } from '../../utils/data.calculate';
import { ActivatedRoute } from '@angular/router';
import { Observable, Observer } from 'rxjs/Rx';

import * as moment from 'moment/moment';
const RE_RENDER_GRAPH = "rerender-graph";
const RE_RENDER_TABLE = "rerender-table";

@Component({
    selector: 'status-report',
    template: require('./statusReport.html'),
    styles: [require('./statusReport.css')]
})
export class StatusReportComponent implements OnInit {
    private selectedView: string = 'graph';
    public warehouseData: any;
    public calculatedWarehouseData: Array<any>;
    public momentData: Array<any> = [];
    private warehouseDataPromise: Promise<any>;
    public questionsString: string;
    public questionLabels: string; public durationValue: string = "1";
    public momentSelected: string = "0";
    public rangeStartTime: string = "";
    public rangeEndTime: string = "";
    public dashboardId: string;
    public activeDashboard: any;
    public myDateRangePickerOptions: any = {};
    public selectedDateRange: string;
    public title: string; public experienceIds: string;
    public components: any;
    public selectedComponent: string;
    public selectedComponentType: string;
    public chartType: string;
    public customLogic: any = {};
    public fromDate: any;
    public toDate: any;
    public selectedDashboardComp: any;
    public selectedMomentLength: number = 0;
    public momentDataCalculated: boolean = false;
    public tabChange: boolean = false;
    public aggregateData: boolean;
    public dataFormat: string;
    public questionsArray: Array<string> = [];
    public regions: any;
    public regionValue: any = 0;
    public company: any = [];
    public allCompanyDD: string = '';
    public userIsnotInAnyCompany: boolean = true;
    public selectedCompany: string = '';
    public enableCompanyFilter: boolean = false;
    public filtersQuestionsData: any;
    public columnType: string;
    public stackArray: any;
    public showQuestion: boolean = false;
    constructor(public dataService: DataService, public dashboardDataUtil: DashboardDataUtility, public activatedRoute: ActivatedRoute) { }

    ngOnInit() {
        console.log("status report init called");
        let activeRoute: string = this.activatedRoute.snapshot.params['id'];
        let dashboard: any;

        this.setDateRangePickerOptions();
        for (let i = 0; i < this.dataService.dashboards.length; i++) {
            if (this.dataService.dashboards[i].id === activeRoute) {
                dashboard = this.dataService.dashboards[i];
                this.activeDashboard = dashboard;
                this.regions = dashboard.region;
                this.enableCompanyFilter = dashboard.enableCompanyFilter
                if (this.enableCompanyFilter) {
                    this.fillCompanyDropDown(dashboard)
                }

            }
        }
        if (this.enableCompanyFilter) {
            this.fillCompanyDropDownForAll()
        }
        //this.title = dashboard.title;
        this.components = dashboard.components;
        this.selectedComponent = dashboard.components[0].name;

        let dashboardId: string = '';
        let experienceIds: string = '';

        for (let j = 0; j < dashboard.experiences.length; j++) {
            if (j === dashboard.experiences.length - 1) {
                experienceIds += dashboard.experiences[j];
            }
            else {
                experienceIds += dashboard.experiences[j] + ','
            }
        }

        this.experienceIds = experienceIds;
        this.dashboardId = dashboard.id;

        let dateRange: Array<string> = this.selectDefaultDateRange();
        this.fromDate = dateRange[1];
        this.toDate = dateRange[0];

        this.getDashboardComponent();
        this.getFilterQuestions();
        if (this.columnType === "questions" || this.columnType === "multiattempt")
            this.showQuestion = true;
    }

    // Identifies whether the selected component is a moment or a non moment component
    getDashboardComponent() {
        let dashboard = this.activeDashboard;

        let questionsString: string = '';
        let questionLabels: string = '';

        for (var i = 0; i < dashboard.components.length; i++) {
            if (dashboard.components[i].name === this.selectedComponent) {
                this.selectedDashboardComp = dashboard.components[i];
                break;
            }
        }

        if (this.selectedDashboardComp.type === "moments") {
            this.selectedComponentType = 'moments';
            this.getMomentConfigurations(this.selectedDashboardComp.moments[0]);
        }
        else {
            this.getDashboardConfigurations(this.selectedDashboardComp);
        }
    }

    // Get moment configuration if selected component is a moment
    getMomentConfigurations(moment) {
        let questionsArray: Array<string>;
        this.selectedMomentLength = moment.charts.length;
        for (let i = 0; i < moment.charts.length; i++) {
            let selectedDashboardComp = moment.charts[i];

            let questionData = this.getQuestionStringsAndLabels(selectedDashboardComp);
            questionsArray = [];

            for (let j = 0; j < selectedDashboardComp.series.length; j++) {
                questionsArray.push(selectedDashboardComp.series[j].key);
            }

            this.momentData.push({
                questionsArray: questionsArray,
                questionString: questionData[0],
                questionLabel: questionData[1],
                title: selectedDashboardComp.title,
                chartType: selectedDashboardComp.chartType,
                customLogic: selectedDashboardComp.customLogic,
                columnType: selectedDashboardComp.columnType,
                aggregateData: typeof selectedDashboardComp.aggregateData !== 'undefined' ? selectedDashboardComp.aggregateData : true,
                dataFormat: selectedDashboardComp.dataFormat ? selectedDashboardComp.dataFormat : 'normal',
                data: null,
                chartData: selectedDashboardComp,
                tableRowLabel: selectedDashboardComp.tableRowLabel ? selectedDashboardComp.tableRowLabel : null,
                stackArray: selectedDashboardComp.customLogic.columns
            });
        }

        this.getDashboardData(new Date(this.fromDate), new Date(this.toDate));
    }

    // Get series names and labels
    getQuestionStringsAndLabels(selectedDashboardComp) {
        let questionsString = "";
        let questionLabels = "";

        for (let j = 0; j < selectedDashboardComp.series.length; j++) {
            if (j === selectedDashboardComp.series.length - 1) {
                questionsString += selectedDashboardComp.series[j].key;
                questionLabels += selectedDashboardComp.series[j].label;
            }
            else {
                questionsString += selectedDashboardComp.series[j].key + ',';
                questionLabels += selectedDashboardComp.series[j].label + ',';
            }

        }

        return [questionsString, questionLabels];
    }

    // Get dropdown changes
    companyChange(evt) {
        this.selectedCompany = evt.target.value;
        this.momentData = [];
        this.getDashboardComponent();
    }

    // Get moment configuration if selected component is non moment
    getDashboardConfigurations(selectedDashboardComp) {

        let questionData = this.getQuestionStringsAndLabels(selectedDashboardComp);

        for (let j = 0; j < selectedDashboardComp.series.length; j++) {
            this.questionsArray.push(selectedDashboardComp.series[j].key);
        }

        this.title = selectedDashboardComp.title;
        this.questionsString = questionData[0];
        this.questionLabels = questionData[1];
        this.chartType = selectedDashboardComp.chartType;
        this.columnType = selectedDashboardComp.columnType;
        this.customLogic = selectedDashboardComp.customLogic;
        this.aggregateData = selectedDashboardComp.aggregateData;
        this.dataFormat = selectedDashboardComp.dataFormat ? selectedDashboardComp.dataFormat : 'normal';
        if (typeof this.aggregateData === 'undefined') {
            this.aggregateData = true;
        }
        this.getDashboardData(new Date(this.fromDate), new Date(this.toDate));
        if (this.columnType === "questions") {
            this.stackArray = this.customLogic.columns;
        }
        else if (this.columnType === "multiattempt") {
            this.stackArray = selectedDashboardComp.columnLabel;
        }
    }

    // Api call to get dashboard Data from backend (handles both moments and non moments)
    getDashboardData(fromDate: Date, endDate: Date) {
        let self = this;
        const selectedFilterQuestion = [];
        if (this.filtersQuestionsData && this.filtersQuestionsData.length) {
            this.filtersQuestionsData.forEach(x => {
                if (x.selectedValue != '') {
                    selectedFilterQuestion.push({
                        question: x.question,
                        response: x.selectedValue
                    })
                }
            })
        }
        if (this.selectedDashboardComp.type !== "moments") {
            return this.dataService.getDashboardData(this.dashboardId, this.questionsString, fromDate, endDate, this.experienceIds, this.customLogic, this.regionValue == "0" ? '' : this.regionValue, this.selectedCompany, selectedFilterQuestion, this.columnType).then((json) => {
                this.warehouseData = json;
                if (!this.aggregateData) {
                    this.calculateDataSumTotal(this.warehouseData, null);
                }
                else {
                    this.calculateData(null);
                }
            });
        }
        else {
            if (this.momentData && this.momentData.length > 0) {
                let promiseArr = [];
                for (let i = 0; i < this.momentData.length; i++) {
                    promiseArr.push(this.dataService.getDashboardData(this.dashboardId, this.momentData[i].questionString, fromDate, endDate, this.experienceIds, this.momentData[i].customLogic, this.regionValue == "0" ? '' : this.regionValue, this.selectedCompany, selectedFilterQuestion))
                }

                Promise.all(promiseArr).then(result => {
                    for (let i = 0; i < self.momentData.length; i++) {
                        self.momentData[i].jsonData = result[i];
                        //self.momentData[i].data = null;
                        if (!self.momentData[i].aggregateData) {
                            this.calculateDataSumTotal(self.momentData[i].jsonData, self.momentData[i]);
                        }
                        else {
                            self.calculateData(self.momentData[i]);
                        }
                    }
                })
            }
        }
    }

    // Gets the total participants in the specified time interval from "calculateSeriesQuestionValueSum" function and re renders graph and table.
    calculateDataSumTotal(data, moment) {
        let questionsArray = moment ? moment.questionsArray : this.questionsArray;
        let sumData;

        sumData = this.dashboardDataUtil.getSeriesQuestionValueSum(data, questionsArray);

        if (moment) {
            moment.data = [sumData];
        }
        else {
            this.calculatedWarehouseData = [sumData];
        }

        this.reRenderGraphAndTable(moment);
    }

    private handleError = (error: any) => {
        // do nothing
    }

    // Toggles the view from graph to table and vice-versa
    toggleView(event) {
        let view = event.currentTarget.getAttribute("data-view");

        if (view === "table") {
            this.selectedView = 'table';
        }
        else {
            this.selectedView = 'graph';
        }
    }

    // Calls the function that formats the data received from backend to a format according to the timeframe
    calculateData(moment) {
        if (this.columnType === "questions") {
            this.calculatedWarehouseData = this.warehouseData.recordSet;
            this.reRenderGraphAndTable(moment);
        }
        else if (this.columnType === "multiattempt") {
            let calculateData = this.warehouseData.recordSet.map(x => x["MultiCount"]);
            let uniqueCount = calculateData.filter((item, i, ar) => ar.indexOf(item) === i);
            this.calculatedWarehouseData = [];
            let sumData: any = [];
            this.calculatedWarehouseData[0] = []
            for (let i = 0; i < uniqueCount.length; i++) {
                this.calculatedWarehouseData[0].push(uniqueCount[i]);
                let count = 0;
                for (let j = 0; j < calculateData.length; j++) {
                    if (uniqueCount[i] <= calculateData[j])
                        count += 1;
                }
                sumData[this.stackArray + "-" + uniqueCount[i]] = count;
            }
            this.calculatedWarehouseData[1] = sumData;
            this.reRenderGraphAndTable(moment);
        }
        else {
            this.durationChange(moment);
        }
    }

    // Gets called when timeframe is changed from the dropdown
    timeframeChange() {
        this.tabChange = false;
        if (this.selectedDashboardComp.type === "moments") {
            for (let i = 0; i < this.momentData.length; i++) {
                //this.momentData[i].data = null;
                if (this.momentData[i].aggregateData) {
                    //this.tabChange = false;
                    this.durationChange(this.momentData[i]);
                }
                else {
                    this.calculateDataSumTotal(this.momentData[i].jsonData, this.momentData[i]);
                }
            }
        }
        else {
            //this.tabChange = false;
            this.durationChange(null);
        }
    }

    regionChange() {
        console.log(this.regionValue);
        this.momentData = [];
        this.getDashboardData(new Date(this.fromDate), new Date(this.toDate));
    }

    // formats the data received from backend to a format according to the timeframe selected
    durationChange(moment) {
        switch (this.durationValue) {
            case "1":
                if (moment !== null) {
                    moment.data = this.dashboardDataUtil.getWeeklyData(moment.jsonData, moment.questionString);
                }
                else {
                    this.calculatedWarehouseData = this.dashboardDataUtil.getWeeklyData(this.warehouseData, this.questionsString);
                }
                break;
            case "2":
                if (moment !== null) {
                    moment.data = this.dashboardDataUtil.getMonthlyData(moment.jsonData, moment.questionString);
                }
                else {
                    this.calculatedWarehouseData = this.dashboardDataUtil.getMonthlyData(this.warehouseData, this.questionsString);
                }
                break;
            case "3":
                if (moment !== null) {
                    moment.data = this.dashboardDataUtil.getDailyData(moment.jsonData, moment.questionString);
                }
                else {
                    this.calculatedWarehouseData = this.dashboardDataUtil.getDailyData(this.warehouseData, this.questionsString);
                }
                break;
            case "4":
                if (moment !== null) {
                    moment.data = this.dashboardDataUtil.getWeeklyData(moment.jsonData, moment.questionString);
                }
                else {
                    this.calculatedWarehouseData = this.dashboardDataUtil.getWeeklyData(this.warehouseData, this.questionsString);
                }
                break;
        }

        this.reRenderGraphAndTable(moment);
    }

    // Re-renders graph and table
    reRenderGraphAndTable(moment) {
        if (moment === null) {
            this.dataService.emitData(RE_RENDER_GRAPH, this.calculatedWarehouseData);
            this.dataService.emitData(RE_RENDER_TABLE, this.calculatedWarehouseData);
        }
        else if (!this.tabChange) {
            this.dataService.emitData(RE_RENDER_GRAPH, moment);
            this.dataService.emitData(RE_RENDER_TABLE, moment);
        }
    }

    // Gets called when moment is changed from the moments dropdown
    momentChange(event) {
        let momentSelected;
        let self = this;

        this.momentData = [];
        momentSelected = this.selectedDashboardComp.moments[parseInt(self.momentSelected)];

        this.getMomentConfigurations(momentSelected);
    }

    // Sets the date range picker
    setDateRangePickerOptions() {
        this.myDateRangePickerOptions = {
            clearBtnTxt: 'Clear',
            beginDateBtnTxt: 'Start Date',
            endDateBtnTxt: 'End Date',
            acceptBtnTxt: 'Apply',
            dateFormat: 'mm/dd/yyyy',
            firstDayOfWeek: 'mo',
            sunHighlight: true,
            height: '34px',
            width: '260px',
            inline: false,
            selectionTxtFontSize: '15px',
            alignSelectorRight: false,
            indicateInvalidDateRange: true,
            showDateRangeFormatPlaceholder: false,
            showClearBtn: false,
            showClearDateRangeBtn: false,
            disableSince: {
                year: moment(new Date()).add(1, 'day').format('YYYY'),
                month: moment(new Date()).add(1, 'day').format('MM'),
                day: moment(new Date()).add(1, 'day').format('DD')
            }
        };
    }

    // Gets called on change of the time duration
    onDateRangeChanged(event: any) {
        this.fromDate = new Date(event.beginDate.year, event.beginDate.month - 1, event.beginDate.day);
        this.toDate = new Date(event.endDate.year, event.endDate.month - 1, event.endDate.day);
        this.tabChange = false;

        return this.getDashboardData(this.fromDate, this.toDate);
    }

    // Default date range for which the data is retrieved from backend
    selectDefaultDateRange(): Array<string> {
        let currentDate = moment(new Date()).format("MM/DD/YYYY");
        let dateBeforeSixWeeks = moment(new Date()).subtract(moment(new Date()).weekday() - 1, 'days').subtract(5, 'weeks').format('MM/DD/YYYY');

        this.selectedDateRange = dateBeforeSixWeeks + ' - ' + currentDate;
        return [currentDate, dateBeforeSixWeeks];
    }

    // Tab change
    selectComponent(event, comp) {
        this.tabChange = true;
        this.momentSelected = "0";
        this.momentData = [];
        this.selectedComponent = comp.name;
        this.selectedComponentType = comp.type;
        this.calculatedWarehouseData = null;
        this.getDashboardComponent();

        //this.dataService.emitData(RE_RENDER_GRAPH, this.calculatedWarehouseData);
        //this.dataService.emitData(RE_RENDER_TABLE, this.calculatedWarehouseData);
    }

    //Get users Company
    fillCompanyDropDown(dashboard) {
        let data = [];
        if (dashboard.company && dashboard.company[0].length > 0) {
            this.userIsnotInAnyCompany = false;
            data = dashboard.company[0];
        }
        else if (dashboard.company && dashboard.company[1] && dashboard.company[1].length > 0) {
            data = dashboard.company[1];
        }
        data.forEach(function (val) {
            if (this.company.indexOf(val.Company) == -1) {
                this.company.push(val.Company)
            }
        }, this)
    }

    // get all company 
    fillCompanyDropDownForAll() {
        this.allCompanyDD = '';
        if (this.userIsnotInAnyCompany) {
            this.selectedCompany = '';
        } else if (this.company.length > 0) {
            this.allCompanyDD = this.company.join(',')
        }
        this.selectedCompany = this.allCompanyDD;
    }

    // get all filter questions response
    getFilterQuestions() {
        const self = this;
        if (this.activeDashboard.filters && this.activeDashboard.filters.length) {
            this.filtersQuestionsData = this.activeDashboard.filters.map((val) => {
                return {
                    question: val.question,
                    select: val.option,
                    label: val.label,
                    responses: [],
                    selectedValue: 0
                }
            })
            this.dataService.getFiltersQuestionsResponse(this.experienceIds, this.activeDashboard.filters.map(x => { return x.question })).then((json) => {
                if (json && json.recordSet) {
                    json.recordSet.forEach(val => {
                        const updateResponse = self.filtersQuestionsData.find(x => { return x.question == val.questionKey });
                        if (updateResponse) {
                            updateResponse.responses.push(val.ResponseText)
                        }
                        //  self.filtersQuestionsData[self.activeDashboard.filtersOnQuestions.indexOf(val.questionKey)].responses.push(val.ResponseText)
                    })
                }
            });
        }
    }
    onFilterQuestionChange(evt, i) {
        const questionValue = evt.target.value;
        this.filtersQuestionsData[i].selectedValue = questionValue;
        this.momentData = [];
        this.getDashboardData(new Date(this.fromDate), new Date(this.toDate));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewsmodule/statusReport/statusReport.ts